<template>
  <div class="customerAdd-container">
    <div class="customeradd-table">
      <el-card shadow="never">添加信息</el-card>
      <el-form :model="formLabelAlign" :rules="rules" ref="formLabelAlign" label-width="120px">
        <el-form-item label="区域:" prop="region">
          <el-select v-model="formLabelAlign.region" placeholder="请选择省">
            <el-option
              v-for="item in localized"
              :key="item.id"
              :label="item.region"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户名称:" prop="customer">
          <el-input v-model="formLabelAlign.customername"></el-input>
        </el-form-item>
        <el-form-item label="交易员:">
          <el-select v-model="formLabelAlign.trader" placeholder="请选择">
            <el-option v-for="item in exchange" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售负责人:">
          <el-select v-model="formLabelAlign.salesman" placeholder="请选择">
            <el-option v-for="item in director" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代理商:">
          <el-select v-model="formLabelAlign.agent" placeholder="请选择">
            <el-option v-for="item in agency" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="$router.back(-1)">取消</el-button>
          <el-button type="primary" @click="customerSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "customerAdd",
  data() {
    return {
      formLabelAlign: {
        customername: "", //客户名称
        trader: "", //交易员
        salesman: "", //销售员
        agent: "", //代理商
        region: "" //省
      },
      exchange: [], //遍历交易员数组
      director: [], //遍历销售员数组
      agency: [], //遍历代理商数组
      localized: [], //遍历省份数组
      rules: {
        region: [
          { required: true, message: "请输入所在城市", trigger: "blur" }
        ],
        customername: [
          { required: true, message: "请输入客户名称", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    // 交易员查询
    this.traderEnquiries();
    //销售负责人查询
    this.getDep();
    //代理商查询
    this.agentEnquiries();
    //省份查询
    this.provinceQuery();
  },
  methods: {
    //调取后端交易员接口
    traderEnquiries: function() {
      const data = {};
      this.$http({
        method: "post",
        url: "/Client/Trader"
      }).then(res => {
        this.exchange = res.data;
      });
    },
    //调取后端销售负责人接口
    getDep: function() {
      const data = {};
      this.$http({
        method: "post",
        url: "/Client/Salesman"
      }).then(res => {
        this.director = res.data;
      });
    },
    //调取后端代理商接口
    agentEnquiries: function() {
      const data = {};
      this.$http({
        method: "post",
        url: "/Client/Agent"
      }).then(res => {
        this.agency = res.data;
      });
    },
    //调取后端省份接口
    provinceQuery: function() {
      const data = {};
      this.$http({
        method: "post",
        url: "/Client/Linkage"
      }).then(res => {
        this.localized = res.data;
      })
    },
    // 提交保存
    customerSubmit() {
      this.$http({
        method: "POST",
        url: "/Client/Add",
        data: {
          capitalid: this.formLabelAlign.region, //省
          customername: this.formLabelAlign.customername, //客户名称
          traderid: this.formLabelAlign.trader, //交易
          agentid: this.formLabelAlign.agent, //代理商
          salesmanid: this.formLabelAlign.salesman //销售
        }
      }).then(res => {
        this.$message({
          type: "success",
          message: "保存成功"
        })
        this.$router.push({ path: "../customer" });
      });
    }
  }
};
</script>

<style lang='less' scoped>
.customeradd-table {
  margin-top: 30px;
}
.el-form {
  margin: 30px 300px;
}
.el-form-item {
  display: inline-block;
}
.el-input {
  width: 450px;
}
.el-select {
  width: 300px;
}
</style>
